module.exports = __webpack_public_path__ + "img/8.782dfe99.jpg";